import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Navbar, Alignment } from '@blueprintjs/core';
import { nanoid } from 'nanoid';

import styled from 'polotno/utils/styled';
import * as api from './api';

const NavbarContainer = styled('div')`
  @media screen and (max-width: 500px) {
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100vw;
  }
`;

const NavInner = styled('div')`
  display: flex;
  justify-content: space-between;
`;

const showAlert = (message) => {
  if (window.Toastify) {
    window
      .Toastify({
        text: message,
        duration: 6000,
        newWindow: true,
        close: false,
        gravity: 'bottom', // `top` or `bottom`
        position: 'center', // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
          background: '#A6A8AB',
          color: '#000',
          width: '100%',
        },
        onClick: function () {}, // Callback after click
      })
      .showToast();
  } else {
    alert(message);
  }
};

const DownloadButton = observer(({ store }) => {
  const [saving, setSaving] = React.useState(false);

  const getName = () => {
    const texts = [];
    store.pages.forEach((p) => {
      p.children.forEach((c) => {
        if (c.type === 'text') {
          texts.push(c.text);
        }
      });
    });
    const allWords = texts.join(' ').split(' ');
    const words = allWords.slice(0, 6);
    return words.join(' ').replace(/\s/g, '-').toLowerCase() || 'polotno';
  };
  return (
    <Button
      fill
      intent="primary"
      loading={saving}
      onClick={async () => {
        setSaving(true);
        await store.saveAsPDF({
          fileName: getName() + '.pdf',
          pixelRatio: 2,
        });
        setSaving(false);
      }}
    >
      Download PDF
    </Button>
  );
});

export const Topbar = observer(({ store }) => {
  const inputRef = React.useRef();

  const [downloading, setDownloading] = React.useState(false);

  return (
    <NavbarContainer className="bp4-navbar">
      <NavInner>
        <Navbar.Group align={Alignment.LEFT}>
          <Button
            icon={
              <img
                src={process.env.PUBLIC_URL + '/icons/new.svg'}
                alt="New"
                style={{ width: '25px' }}
              />
            }
            minimal
            onClick={() => {
              const ids = store.pages
                .map((page) => page.children.map((child) => child.id))
                .flat();
              const hasObjects = ids?.length;
              if (hasObjects) {
                if (!window.confirm('Clear this artboard and start fresh?')) {
                  return;
                }
              }
              const elementsToDelete = [];
              store.pages.forEach((page) => {
                page.children.forEach((child) => {
                  if (child.selectable) {
                    elementsToDelete.push(child.id);
                  }
                });
              });
              store.deleteElements(elementsToDelete);
            }}
          >
            New
          </Button>
          <label htmlFor="load-project">
            <input
              type="file"
              id="load-project"
              accept=".json,.polotno"
              ref={inputRef}
              style={{ width: '180px', display: 'none' }}
              onChange={(e) => {
                var input = e.target;

                if (!input.files.length) {
                  return;
                }

                var reader = new FileReader();
                reader.onloadend = function () {
                  var text = reader.result;
                  let json;
                  try {
                    json = JSON.parse(text);
                  } catch (e) {
                    showAlert('Can not load the project.');
                  }

                  if (json) {
                    store.loadJSON(json);
                    input.value = '';
                  }
                };
                reader.onerror = function () {
                  showAlert('Can not load the project.');
                };
                reader.readAsText(input.files[0]);
              }}
            />
          </label>
          <Button
            icon={
              <img
                src={process.env.PUBLIC_URL + '/icons/save.svg'}
                style={{ width: '25px' }}
              />
            }
            minimal
            onClick={async () => {
              await api.saveArtboard({
                artboardJson: store.toJSON(),
                id: nanoid(10),
                preview: await store.toDataURL({ pixelRatio: 0.2 }),
              });
              showAlert('Saved');
              const event = new CustomEvent('artboardSaved');
              window.dispatchEvent(event);
            }}
            className="loginOverlay_open"
          >
            Save
          </Button>
        </Navbar.Group>
        <Navbar.Group align={Alignment.LEFT}>
          <a href="http://carvart.com/" target="_blank">
            <img
              src={process.env.PUBLIC_URL + '/carvart-logo-white.svg'}
              style={{ height: '13px' }}
            />
          </a>
        </Navbar.Group>
        <Navbar.Group align={Alignment.RIGHT}>
          <Button
            icon={
              <img
                src={process.env.PUBLIC_URL + '/icons/tutorial.svg'}
                style={{ width: '25px' }}
              />
            }
            minimal
            className="artboardTutorial_open"
          >
            Tutorial
          </Button>
          <Button
            icon={
              <img
                src={process.env.PUBLIC_URL + '/icons/download.svg'}
                style={{ width: '25px' }}
              />
            }
            minimal
            loading={downloading}
            onClick={async () => {
              setDownloading(true);
              await store.saveAsPDF({
                fileName: 'carvart.pdf',
                pixelRatio: 2,
                dpi: 113,
              });
              setDownloading(false);
            }}
            className="loginOverlay_open"
          >
            Download PDF
          </Button>
        </Navbar.Group>
      </NavInner>
    </NavbarContainer>
  );
});
